
(function () {
    var window_width = null;
    let isMobile = false;
    let menu = document.getElementById("menu");
    let statusOpenMenu = false;
    let statusOpenSubmenu = false;
    var btnMenu = null;
    var submenus = null;
    var btnSubmenu = null;

    var optionLevelOne = null;
    var optionLevelTwo = null;

    var isMenuOpen = false;
    var isSubmenuOpen = false;
    var isSubmenuGrandChildOpen = false;

    var sectionHeader = null;
    var sectionHeaderValue = null;


    document.addEventListener("DOMContentLoaded", (ev) => {

        // console.log('dom loaded')
        widthActual();
        getDevice();
        getTypeHeader();

        submenus = document.getElementsByClassName('submenu');
        btnSubmenu = document.getElementsByClassName('btn-submnenu');

        optionLevelOne = document.getElementsByClassName('menu-item');
        optionLevelTwo = document.getElementsByClassName('submenu-item');

        $("#btn-menu").click(function () {

            console.log('#btn menu clicked')
            isMenuOpen = !isMenuOpen;

            if (isMenuOpen == true) {
                $("#menu").slideDown();
                console.log('slidedown fired')
            } else {
                $("#menu").slideUp();
                console.log('slideup fired')
            }
        });

        hiddeMenuMobile();

        for (let i = 0; i < optionLevelOne.length; i++) {
            optionLevelOne[i].addEventListener("mouseenter", function () {
                var btnCollapserSecondLevel = this.querySelector(".btn-submnenu");
                var btnSubList = this.querySelector('.menu-item__sublist');
                var btnSubListLink = this.querySelector('.menu-item__link');
                var submenuBtnToggle = this.querySelector('.btn-submnenu');

                if (submenuBtnToggle) {
                    var submenuBtnToggleIcon = this.querySelector('.icon');
                }

                $(btnSubList).addClass('hover');

                if (btnSubListLink) {
                    $(btnSubListLink).addClass('hover');
                }

                if (btnCollapserSecondLevel) {
                    isSubmenuOpen = true;
                    $(submenuBtnToggleIcon).addClass('hover');

                    if (isSubmenuOpen == true) {
                        btnCollapserSecondLevel.ariaExpanded = 'true';
                        let submenu = btnCollapserSecondLevel.parentElement.parentElement.parentElement.nextElementSibling;
                        $(submenu).slideDown('slow');
                    }
                }
            });
        }

        for (let i = 0; i < optionLevelOne.length; i++) {
            optionLevelOne[i].addEventListener("mouseleave", function () {
                var btnCollapserSecondLevel = this.querySelector(".btn-submnenu");
                var btnSubList = this.querySelector('.menu-item__sublist');
                var btnSubListLink = this.querySelector('.menu-item__link');
                var submenuBtnToggle = this.querySelector('.btn-submnenu');

                if (submenuBtnToggle) {
                    var submenuBtnToggleIcon = submenuBtnToggle.querySelector('.icon');
                }

                $(btnSubList).removeClass('hover');

                if (btnSubListLink) {
                    $(btnSubListLink).removeClass('hover');
                }

                if (btnCollapserSecondLevel) {
                    $(submenuBtnToggleIcon).removeClass('hover');
                    btnCollapserSecondLevel.ariaExpanded = 'false';
                    isSubmenuOpen = false;
                    let submenu = btnCollapserSecondLevel.parentElement.parentElement.parentElement.nextElementSibling;
                    $(submenu).slideUp('slow');
                }
            });
        }

        for (let i = 0; i < optionLevelOne.length; i++) {
            optionLevelOne[i].addEventListener("mousedown", function (e) {
                var btnCollapserSecondLevel = this.querySelector(".btn-submnenu");
                var btnSubList = this.querySelector('.menu-item__sublist');
                var submenuBtnToggle = this.querySelector('.btn-submnenu');

                if (submenuBtnToggle) {
                    var submenuBtnToggleIcon = submenuBtnToggle.querySelector('.icon');
                }

                if (isSubmenuGrandChildOpen == true) {
                    e.preventDefault();
                }

                let submenu = btnCollapserSecondLevel.parentElement.parentElement.parentElement.nextElementSibling;

                if (isSubmenuGrandChildOpen != true) {

                    if (isSubmenuOpen == true && isSubmenuGrandChildOpen == false) {
                        isSubmenuOpen = false;
                        $(submenu).slideDown('slow');
                        $(btnSubList).addClass('hover');
                        $(submenuBtnToggleIcon).addClass('hover');

                    } else if (isSubmenuOpen == false && isSubmenuGrandChildOpen == false) {
                        isSubmenuOpen = true;
                        $(submenu).slideUp('slow');
                        $(btnSubList).removeClass('hover');
                        $(submenuBtnToggleIcon).removeClass('hover');

                    } else if (isSubmenuGrandChildOpen == true) {
                        isSubmenuOpen = true;
                        submenu.style.display = 'block';
                    }
                }
            });
        }

        for (let i = 0; i < optionLevelTwo.length; i++) {
            optionLevelTwo[i].addEventListener("mouseenter", function () {
                var submenuGrandchild = this.querySelector('.submenu-item__grandchild');
                var submenuBtnToggle = this.querySelector('.btn-submnenu');

                if (submenuBtnToggle) {
                    var submenuBtnToggleIcon = submenuBtnToggle.querySelector('.icon');
                }

                if (submenuGrandchild) {
                    isSubmenuGrandChildOpen = true;

                    $(optionLevelTwo[i]).addClass('hover2');
                    $(submenuBtnToggleIcon).addClass('hover2');

                    if (isSubmenuGrandChildOpen == true) {
                        if (isMobile == true) {
                            $(submenuGrandchild).slideDown();
                        } else {
                            $(submenuGrandchild).show();
                        }
                    }
                }
            });
        }

        for (let i = 0; i < optionLevelTwo.length; i++) {
            optionLevelTwo[i].addEventListener("mouseleave", function () {
                var submenuGrandchild = this.querySelector('.submenu-item__grandchild');
                var submenuBtnToggle = this.querySelector('.btn-submnenu');

                if (submenuBtnToggle) {
                    var submenuBtnToggleIcon = submenuBtnToggle.querySelector('.icon');
                }

                if (submenuGrandchild) {
                    isSubmenuOpen = false;
                    isSubmenuGrandChildOpen = false;
                    $(optionLevelTwo[i]).removeClass('hover2');
                    $(submenuBtnToggleIcon).removeClass('hover2');

                    if (isMobile == true) {
                        $(submenuGrandchild).slideUp();
                    } else {
                        $(submenuGrandchild).hide();
                    }
                }
            });
        }

        for (let i = 0; i < optionLevelTwo.length; i++) {
            optionLevelTwo[i].addEventListener("mousedown", function () {
                var submenuGrandchild = this.querySelector('.submenu-item__grandchild');
                var submenuBtnToggle = this.querySelector('.btn-submnenu');

                if (submenuBtnToggle) {
                    var submenuBtnToggleIcon = submenuBtnToggle.querySelector('.icon');
                }

                if (isSubmenuOpen == true && isSubmenuGrandChildOpen == true) {
                    $(submenuGrandchild).slideUp('slow');
                    $(optionLevelTwo[i]).removeClass('hover2');
                    isSubmenuOpen = false;
                    $(submenuBtnToggleIcon).removeClass('hover2');

                } else if (isSubmenuOpen == false && isSubmenuGrandChildOpen == true) {
                    $(submenuGrandchild).slideDown('slow');
                    isSubmenuOpen = true;
                }
            });
        }
    });

    // $(document).ready();

    function widthActual() {
        window_width = window.innerWidth;
    }

    function getStatusSubmenu() {
        if (statusOpenSubmenu) {
            $(this).parent().parent().addClass("open");
        } else {
            setTimeout(() => {
                $(this).parent().parent().removeClass("open");
            }, 500);
        }
    }

    this.addEventListener("resize", (event) => {
        console.log("Resize event triggered!");
        console.log(menu);

        widthActual();
        getDevice();

        let menuDisplay = menu.style.display;
        let submenuDisplay = menu.style.display;

        if (window_width > 768) {
            isMenuOpen = false;
        }

        if (window_width < 768 && menuDisplay === 'block' && isMenuOpen == false) {
            $(menu).hide();
            isMenuOpen = false;
        } else if (window_width > 768 && menuDisplay === 'none' && isMenuOpen == false) {
            $(menu).show();
            isMenuOpen = false;
        }
    });

    function getDevice() {
        let navigatorDevice = navigator.userAgent;
        if (navigatorDevice.match(/Android/i) || navigatorDevice.match(/webOS/i) || navigatorDevice.match(/iPhone/i) || navigatorDevice.match(/iPad/i) || navigatorDevice.match(/iPod/i) || navigatorDevice.match(/BlackBerry/i) || navigatorDevice.match(/Windows Phone/i)) {
            isMobile = true;
        } else {
            isMobile = false;
        }
    }

    function getTypeHeader() {
        sectionHeader = document.getElementById('shopify-section-header');

        inputHeaderType = document.getElementById('sticky-header');

        inputHeaderTypeValue = inputHeaderType.value;

        $(inputHeaderTypeValue).on("change", function () {
        })

        if (inputHeaderTypeValue == 'yes') {
            $(sectionHeader).addClass('stiky-menu');
        } else if (inputHeaderTypeValue == 'no') {
            $(sectionHeader).removeClass('stiky-menu');
        }
    }

    function hiddeMenuMobile() {

        btnMenu = document.getElementById("btn-menu");

        window.addEventListener('click', function (e) {

            if (isMenuOpen == true) {

                if (!document.getElementById('siteHeaderId').contains(e.target)) {
                    $(menu).slideUp("slow");
                    isMenuOpen = false;
                }
            } else {
                isMenuOpen = false
            }
        });
    }
})($)
